import { checkStatus, generateURL } from 'utils/helpers';

const availability = {
  unavailableDates: ({ resourceIDs, fromDate, toDate }) => {
    const url = generateURL('/availability/unavailable_dates', {
      resource_ids: resourceIDs,
      date_from: fromDate,
      date_to: toDate,
    });

    return fetch(url).then((response) => response.json());
  },

  dateRangeBookability: ({
    resourceIds,
    passengerTypeNumbers,
    fromDate,
    toDate,
  }) => {
    const url = generateURL('/availability/date_range_bookability', {
      resource_ids: resourceIds,
      passenger_type_numbers: passengerTypeNumbers,
      date_from: fromDate,
      date_to: toDate,
    });

    return fetch(url, {
      method: 'GET',
    }).then((response) => checkStatus(response));
  },
};

export default availability;
